import { render, staticRenderFns } from "./trusted_vpn.vue?vue&type=template&id=669858dc&scoped=true&"
import script from "./trusted_vpn.vue?vue&type=script&lang=js&"
export * from "./trusted_vpn.vue?vue&type=script&lang=js&"
import style0 from "./trusted_vpn.vue?vue&type=style&index=0&id=669858dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669858dc",
  null
  
)

export default component.exports